/**
 * FLUXO DE CAIXA: AS REGRAS DOS NÚMEROS (11/10/2026, medição do Fluxo de Caixa). É tela de decisão: número velho com cara
 * de atual é o risco. Funções puras que a tela usa e os testes cobram dos dois lados.
 */

export const rotuloDoPeriodo = (meses: number) => (meses === 1 ? '1 mês' : `${meses} meses`);

/**
 * D2: o "Saldo em Contas" somava todas as contas, inclusive INATIVAS e as de INVESTIMENTO (cotas × a última posição, que
 * congela sem posição nova e tem parte presa pelo IOF). Caixa é o que está disponível; aplicado vai ao lado.
 */
export function saldosDasContas(contas: any[]): { caixa: number; aplicado: number; contasAplicadas: number; inativasFora: number } {
  const valor = (c: any) => parseFloat(c?.currentBalance) || 0;
  const ativas = (contas || []).filter((c) => c?.isActive !== false);
  const investimento = (c: any) => c?.accountType === 'investimento';
  return {
    caixa: ativas.filter((c) => !investimento(c)).reduce((s, c) => s + valor(c), 0),
    aplicado: ativas.filter(investimento).reduce((s, c) => s + valor(c), 0),
    contasAplicadas: ativas.filter(investimento).length,
    inativasFora: (contas || []).length - ativas.length,
  };
}

/** D3: o mês sem receita e sem despesa some do gráfico; a tela diz quais foram. É zero de verdade, não falha de leitura. */
export function mesesSemMovimento(meses: Array<{ month: string; revenue?: any; expenses?: any }>): string[] {
  return (meses || [])
    .filter((m) => (parseFloat(m.revenue) || 0) === 0 && (parseFloat(m.expenses) || 0) === 0)
    .map((m) => m.month);
}

export function fraseDosMesesSemMovimento(meses: string[], fmtMes: (m: string) => string): string | null {
  if (meses.length === 0) return null;
  const lista = meses.slice(0, 6).map(fmtMes).join(', ');
  const resto = meses.length > 6 ? ` e mais ${meses.length - 6}` : '';
  return `${meses.length} ${meses.length === 1 ? 'mês' : 'meses'} sem movimento no período, fora do gráfico e da tabela: ${lista}${resto}. Faturamento ou despesa ainda não lançados ficam assim.`;
}

/** D1: a recarga que falha mantém os números anteriores; a faixa diz de quando e de qual período eles são. */
export function fraseDaRecargaQueFalhou(pedido: number, dosDados: number, quando: string, erro: string | null): string {
  const hora = new Date(quando).toLocaleTimeString('pt-BR', { timeZone: 'America/Sao_Paulo', hour: '2-digit', minute: '2-digit' });
  return `Não consegui carregar ${rotuloDoPeriodo(pedido)}${erro ? ` (${erro})` : ''}. Os números abaixo são de ${hora}, período de ${rotuloDoPeriodo(dosDados)}.`;
}

/** D5: DRE e Analítico são por competência. Lidos como caixa, mentem. */
export const FRASE_DA_COMPETENCIA = 'Por competência: o que foi faturado e o que está previsto no mês de referência, não o que entrou ou saiu do caixa.';
